export const MOBILE_PROVIDERS = {
    BANNO: "BANNO",
    NCRDI: "NCRDI",
    HOMECU: "HOMECU",
    NARMI: "NARMI",
    MEA: "MEA",
    ALKAMI: "ALKAMI",
    CANDESCENT: "CANDESCENT",
  };
  